import { translate } from '@thoughtspot/i18n';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Table } from '@thoughtspot/radiant-react/widgets/table';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import styles from '../spotbuild-integration.module.scss';
export const PreviewTablePanel = ({ data, columns, onScrollCapture, }) => (React.createElement(Vertical, { className: styles.tableSection, grow: true, basis: "60%", vAlignContent: "center", onScrollCapture: onScrollCapture },
    React.createElement("div", { className: styles.tableHeader },
        React.createElement(Typography, { variant: "p", className: styles.tableHeaderTitle }, translate('sparkflow.build.previewTable.title'))),
    React.createElement(Table, { data: data ?? [], columns: columns, className: styles.table })));
//# sourceMappingURL=preview-table-panel.js.map